import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: '',
    drawer: null,
    ua: '',
    isInCall: false,
    isCallOut: 0,
    permissions: [],
    module: {
      schoolLevelId: '',
      typeId: ''
    },
    isManager: 0,
    listType: null,
    listSchoolLevel: null,
    statusTutor:false,
    vhData: {},
    listActionLogType: null,
    isAutoCall: false,
    listContact: [],
    autoCallIndex: 0,
    isCallWithBrandName: false,
    selectedCallOptions: { type: 'auto' },
    isInitCareSoft: false,
    isInitOds: false,
    isDefaultAuto: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_UA (state, payload) {
      state.ua = payload
    },
    SET_IN_CALL (state, payload) {
      state.isInCall = payload
    },
    SET_CALL_OUT (state, payload) {
      state.isCallOut = payload
    },
    SET_PERMISSION (state, payload) {
      state.permissions = payload
    },
    SET_MANAGER (state, payload) {
      state.isManager = payload
    },
    SET_MODULE (state, payload) {
      state.module = payload
    },
    SET_LIST_TYPE (state, payload) {
      state.listType = payload
    },
    SET_LIST_SCHOOL_LEVEL (state, payload) {
      state.listSchoolLevel = payload
    },
    CHECK_STATUS_QUICKVIEW(state, payload) {
      state.statusTutor = payload
    },
    SET_VH_UPDATE_DATA (state, payload) {
      for (const [key, value] of Object.entries(payload)) {
        state.vhData[key] = value
      }
    },
    SET_LIST_ACTION_LOG_TYPE (state, payload) {
      state.listActionLogType = payload
    },
    SET_AUTO_CALL_STATE (state, payload) {
      state.isAutoCall = payload;
    },
    SET_AUTO_CALL_INDEX (state, payload) {
      state.autoCallIndex = payload;
    },
    SET_LIST_CONTACT (state, payload) {
      state.listContact = payload;
    },
    SET_CALL_WITH_BRAND_NAME (state, payload) {
      state.isCallWithBrandName = payload;
    },
    SET_SELECTED_CALL_OPTION (state, payload) {
      state.selectedCallOptions = payload;
    },
    SET_IS_INIT_CARE_SOFT (state, payload) {
      console.log('SET_IS_INIT_CARE_SOFT', payload);
      state.isInitCareSoft = payload;
    },
    SET_IS_INIT_ODS (state, payload) {
      console.log('SET_IS_INIT_ODS', payload);
      state.isInitOds = payload;
    },
    SET_DEFAULT_TYPE_AUTO (state, payload) {
      state.isDefaultAuto = payload;
    },
  },
  actions: {
    SET_UA (store, ua) {
      store.commit('SET_UA', ua)
    },
    SET_IN_CALL (store, isInCall) {
      store.commit('SET_IN_CALL', isInCall)
    },
    SET_CALL_OUT (store, isCallOut) {
      store.commit('SET_CALL_OUT', isCallOut)
    },
    SET_PERMISSION (store, permissions) {
      store.commit('SET_PERMISSION', permissions)
    },
    SET_MANAGER (store, isManager) {
      store.commit('SET_MANAGER', isManager)
    },
    SET_MODULE (store, module) {
      store.commit('SET_MODULE', module)
    },
    SET_LIST_TYPE (store, listType) {
      store.commit('SET_LIST_TYPE', listType)
    },
    SET_LIST_SCHOOL_LEVEL (store, listSchoolLevel) {
      store.commit('SET_LIST_SCHOOL_LEVEL', listSchoolLevel)
    },
    SET_VH_UPDATE_DATA (store, vhData) {
      store.commit('SET_VH_UPDATE_DATA', vhData)
    },
    SET_LIST_ACTION_LOG_TYPE (store, listActionLogType) {
      store.commit('SET_LIST_ACTION_LOG_TYPE', listActionLogType)
    }
  },
})
